module.exports = __webpack_public_path__ + "static/media/amex.44f5cd5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardicons/amex.png
// module id = 1026
// module chunks = 0